import React from 'react'
import './presentationReferral.sass'
import {CSSTransitionGroup} from 'react-transition-group'
import RenderConsent from './subcomponents/renderConsent.js'
import RenderOutro from './subcomponents/renderOutro.js'
import PVHeader from './subcomponents/pvHeader.js'
import PVBody from './subcomponents/pvBody.js'
import FinalScreen from '../finalScreen.js'

function RenderPV(props) {
	const {
		pvData,
		pvEndData,
		questionID,
		handleReply,
		handleConsent,
		sendData,
		pvOptionsHash,
		lang,
		pvAnswer,
		setPVAnswer,
		client,
		userID,
		identifier,
		returnHandler
	} = props

	let questionAmount = 1

	if (questionID === questionAmount){
		return(
			<FinalScreen
				pvData={pvData}
				pvEndData={pvEndData}
				outroData={pvData}
				sendData={sendData}
				lang={lang}
				returnHandler={returnHandler}
			/>
		)
	} else {
		return(
			<div className='pv'>
				<PVHeader
					pvEndData={pvEndData}
					lang={lang}
				/>
				<PVBody
					pvData={pvData} 
					questionID={questionID}
					handleReply={handleReply}
					pvOptionsHash={pvOptionsHash}
					lang={lang}
					setPVAnswer={setPVAnswer}
				/>
			</div>
		)
	}
}

export default class PV extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			questionID: 0,
			sendData: false,
			pvAnswer: {"answers":[]}
		}
	}

	handleReply = () => {
		const {questionID} = this.state
		let newQuestionID = questionID + 1
		this.setState({
			questionID: newQuestionID
		})
	}

	handleConsent = (a) => {
		const {questionID} = this.state
		let newQuestionID = questionID + 1
		this.setState({
			questionID: newQuestionID,
			sendData: true
		})
	}

	setPVAnswer = answer => {
		const {pvAnswer} = this.state
		let newAnswer = pvAnswer
		newAnswer.answers.push(answer)
		this.setState({
			pvAnswer: newAnswer
		})
	}

	render(){
		const {
			pvData,
			pvEndData,
			pvOptionsHash,
			lang,
			client,
			userID,
			identifier,
			returnHandler
		} = this.props

		const {
			questionID,
			sendData,
			pvAnswer,
		} = this.state

		let questionLength = 1
		let key

		if (questionID === questionLength){
			key = 'renderConsent'
		} else if (questionID === questionLength+1){
			key = 'renderOutro'
		} else {
			key = 'renderQuestion'
		}

		return(
			<CSSTransitionGroup
				transitionName="pv-background"
				transitionAppear={true}
				transitionAppearTimeout={1100}
				transitionEnterTimeout={1100}
				transitionLeaveTimeout={1100}>
				<RenderPV 
					key={key}
					pvData={pvData}
					pvEndData={pvEndData}
					questionID={questionID}
					handleReply={this.handleReply}
					handleConsent={this.handleConsent}
					sendData={sendData}
					pvOptionsHash={pvOptionsHash}
					lang={lang}
					pvAnswer={pvAnswer}
					setPVAnswer={this.setPVAnswer}
					client={client}
					userID={userID}
					identifier={identifier}
					returnHandler={returnHandler}
				/>
			</CSSTransitionGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/presentationReferral/presentationReferral.js